import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import * as moment from 'moment';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.scss'],
})
export class CalendarioComponent implements OnInit, OnChanges {

  @Input() data;
  @Input() dataMin;
  @Input() dataMax;
  @Output() dataChange = new EventEmitter<string>();

  @Input() format: string = 'DD/MM/YYYY';

  hoje: moment.Moment;
  diasMes: number;
  labelMouth: string;
  labelYear: string;
  mes: any;

  diaSelecionado: any;

  constructor(
    private popoverController: PopoverController
  ) {
    this.hoje = moment();
  }

  ngOnInit() {
    console.log('==========Init', this.dataMin, this.dataMax);
    this.carregar();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      console.log('changes.data', changes.data);
      if (changes.data.currentValue && changes.data.currentValue.length == 10) {
        let digitado = moment(changes.data.currentValue, 'DD/MM/YYYY');

        this.diaSelecionado = digitado;
        this.hoje = moment(`01/${digitado.format('MM')}/${digitado.format('YYYY')}`, 'DD/MM/YYYY');
        this.carregar();
      }
    }
  }

  adicionarDiaMes(semana, dado) {
    if (!this.mes[semana]) {
      this.mes.push([])
    }
    this.mes[semana].push(dado);
  }

  iniciandoMes() {
    this.mes = [
      [{ dia: 'D', class: 'titulo' }, { dia: 'S', class: 'titulo' }, { dia: 'T', class: 'titulo' }, { dia: 'Q', class: 'titulo' }, { dia: 'Q', class: 'titulo' }, { dia: 'S', class: 'titulo' }, { dia: 'S', class: 'titulo' }]
    ];
  }

  blockData(data) {

    console.log('==========', data, this.dataMin, this.dataMax);
    if (this.dataMin) {
      let dataMin = moment(this.dataMin, 'DD/MM/YYYY');
      if (data.isBefore(dataMin)) {
        return true;
      }
    }
    if (this.dataMax) {
      let dataMax = moment(this.dataMax, 'DD/MM/YYYY');
      if (data.isAfter(dataMax)) {
        return true;
      }
    }


    return false;
  }

  textoBlock(data) {
    if (data && this.dataMin) {
      let dataMin = moment(this.dataMin, 'DD/MM/YYYY');
      if (data.isBefore(dataMin)) {
        return `Data inferior a data ${this.dataMin}`;
      }
    }
    if (data && this.dataMax) {
      let dataMax = moment(this.dataMax, 'DD/MM/YYYY');
      if (data.isAfter(dataMax)) {
        return `Data superior a data  ${this.dataMax}`;
      }
    }

    return '';
  }

  async blockeado(ev, data) {

  }

  carregar() {
    this.iniciandoMes();
    this.diasMes = this.hoje.daysInMonth();
    let semana = 1;
    let primeiroDia = moment(`01/${this.hoje.format('MM')}/${this.hoje.format('YYYY')}`, 'DD/MM/YYYY');
    let ultimoDia = moment(`${this.diasMes}/${this.hoje.format('MM')}/${this.hoje.format('YYYY')}`, 'DD/MM/YYYY');

    let mesAnterior = this.retornaMesAnterior();
    let qtDiaMesAnterior = mesAnterior.daysInMonth();
    for (let c = 0; c < this.diaSemana(primeiroDia); c++) {
      let pDia = qtDiaMesAnterior - this.diaSemana(primeiroDia) + c + 1;
      let dia = moment(`${pDia}/${mesAnterior.format('MM')}/${mesAnterior.format('YYYY')}`, 'DD/MM/YYYY');
      this.adicionarDiaMes(semana, {
        dia: pDia,
        moment: dia,
        class: 'dom',
        block: this.blockData(dia)
      });
    }

    for (let c = 1; c <= this.diasMes; c++) {
      let dia = moment(`${c}/${this.hoje.format('MM')}/${this.hoje.format('YYYY')}`, 'DD/MM/YYYY');

      this.adicionarDiaMes(semana, {
        dia: c,
        moment: dia,
        class: this.diaSemana(dia) == 0 ? '' : '',
        block: this.blockData(dia)
      });
      if (this.diaSemana(dia) == 6) {
        semana++;
      }
    }

    let diaMesPosterior = 1;
    let mesPosterior = this.retornaMesPosterior();
    for (let c = this.diaSemana(ultimoDia) + 1; c <= 6; c++) {

      let dia = moment(`${diaMesPosterior}/${mesPosterior.format('MM')}/${mesPosterior.format('YYYY')}`, 'DD/MM/YYYY');

      this.adicionarDiaMes(semana, { dia: diaMesPosterior, moment: dia, class: 'dom', block: this.blockData(dia) });
      diaMesPosterior++;
    }

    this.labelMouth = this.hoje.format('MMMM');
    this.labelYear = this.hoje.format('YYYY');
  }

  diaSemana(data: moment.Moment): number {
    let diaSemana = parseInt(data.format('E'));
    return diaSemana == 7 ? 0 : diaSemana;
  }

  selecionar(dia) {
    if (dia.moment) {
      this.diaSelecionado = dia.moment;
      this.popoverController.dismiss(dia.moment);
      // this.dataChange.emit(dia.moment.format(this.format));
    }

  }

  proximo() {
    let mes = this.hoje.format('MM');
    let ano = this.hoje.format('YYYY');
    if (parseInt(mes) == 12) {
      mes = '01';
      ano = (parseInt(this.hoje.format('YYYY')) + 1) + '';
    } else {
      mes = (parseInt(mes) + 1) + ''
    }
    this.hoje = moment(`01/${mes}/${ano}`, 'DD/MM/YYYY');
    this.carregar();
  }

  anterior() {

    let mes = this.hoje.format('MM');
    let ano = this.hoje.format('YYYY');
    if (parseInt(mes) == 1) {
      mes = '12';
      ano = (parseInt(this.hoje.format('YYYY')) - 1) + '';
    } else {
      mes = (parseInt(mes) - 1) + '';
    }

    this.hoje = moment(`01/${mes}/${ano}`, 'DD/MM/YYYY');

    this.carregar();
  }

  anteriorAno() {

    let mes = this.hoje.format('MM');
    let ano = (parseInt(this.hoje.format('YYYY')) - 1) + '';
    this.hoje = moment(`01/${mes}/${ano}`, 'DD/MM/YYYY');
    this.carregar();
  }

  proximoAno() {
    let mes = this.hoje.format('MM');
    let ano = (parseInt(this.hoje.format('YYYY')) + 1) + '';
    this.hoje = moment(`01/${mes}/${ano}`, 'DD/MM/YYYY');
    this.carregar();
  }


  retornaMesAnterior() {
    let mes = this.hoje.format('MM');
    let ano = this.hoje.format('YYYY');
    if (parseInt(mes) == 1) {
      mes = '12';
      ano = (parseInt(this.hoje.format('YYYY')) - 1) + '';
    } else {
      mes = (parseInt(mes) - 1) + '';
    }

    return moment(`01/${mes}/${ano}`, 'DD/MM/YYYY');
  }

  retornaMesPosterior() {
    let mes = this.hoje.format('MM');
    let ano = this.hoje.format('YYYY');
    if (parseInt(mes) == 12) {
      mes = '01';
      ano = (parseInt(this.hoje.format('YYYY')) + 1) + '';
    } else {
      mes = (parseInt(mes) + 1) + ''
    }
    return moment(`01/${mes}/${ano}`, 'DD/MM/YYYY');
  }

}
